/**
 * 转换阿拉伯数字与中文数字
 */

import Nzh from 'nzh'

export const nzh = Nzh.cn
